import HttpService from '@/services/http/http.service';

export default class AdminStudentService {
	constructor() {
		this.http = new HttpService();
	}

	privateKey(userId) {
		return this.http.get(`admin/student/${userId}/private-key`);
	}
}
